import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from "@angular/http";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { config } from "../../../../environments/config";
import "rxjs/add/operator/toPromise";

@Injectable()
export class WebService {
  public apiUrl = config.API_ROOT;
  public headers: Headers = new Headers({ "Content-Type": "application/json" });
  public options: RequestOptions;
  public progress$: Observable<number>;
  constructor(public http: Http, public router: Router) {
    this.refreshToken();
  }

  public refreshToken() {
    this.headers = new Headers({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    });
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/web.service.ts